import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`

export const Label = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: var(--foreground-neutral, #14171f);
`

export const LabelOptional = styled.label`
  color: var(--foreground-neutral-faded, var(--foreground-neutral-faded, #4d5874));

  /* Body 3/Regular */
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const TextInputContainer = styled.div<{ error?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border: 1px solid ${({ error }) => (error ? 'var(--border-critical, #CB101D)' : 'var(--border-neutral, #bbc1d3)')};
  background: var(--background-elevation-base, #fff);
  border-radius: 6px;
  padding: 8px;
  box-sizing: border-box;
  height: 36px;

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    padding: 12px 16px;

    height: 48px;
  }
`

export const TitleSelect = styled.div`
  color: var(--foreground-neutral, #14171f);
  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`

export const TextInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  color: var(--foreground-neutral, #14171f);
  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding: 0;

  ::placeholder {
    color: var(--foreground-neutral-faded, #4d5874);
    opacity: 0.5;

    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-style: normal;
    font-weight: 400;

    @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
      font-size: 16px;
    }
  }

  :disabled {
    background-color: white;
  }
`

export const Placeholder = styled.div`
  opacity: 0.5;
  color: var(--foreground-neutral-faded, #4d5874);
  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    font-size: 16px;
  }
`

export const FakeInput = styled.input`
  opacity: 0;
  position: absolute;
  height: 0px;
  width: 0px;
  padding-top: 16px;
`

export const ContainerSelect = styled.div<{ width?: number; dropdownAutoWidth: boolean }>`
  max-height: 210px;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  /* gap: 4px; */

  padding: 4px 4px;
  box-sizing: border-box;

  border-radius: 8px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-overlay, #fff);

  /* Overlay */
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07), 0px 5px 10px 0px rgba(0, 0, 0, 0.05);

  width: ${({ width, dropdownAutoWidth }) => (dropdownAutoWidth ? 'auto' : `${width}px`)};

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    max-height: 316px;
    width: 100vw;
    padding-bottom: var(--safe-area-inset-bottom, 0px);
  }
`

export const Item = styled.div<{ disabled?: boolean; selected?: boolean; highlighted?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;

  padding: 10px 12px;
  /* margin: 2px 0; */
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  border-radius: 4px;

  background-color: ${({ selected, highlighted }) =>
    selected
      ? 'var(--background-neutral, #bbc1d3)'
      : highlighted
      ? 'var(--background-neutral, rgba(223, 226, 234, 0.4))'
      : 'white'};

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    padding: 12px 16px;

    background-color: ${({ selected, highlighted }) =>
      selected
        ? 'rgba(90, 88, 242, 0.12)'
        : highlighted
        ? 'var(--background-neutral, rgba(223, 226, 234, 0.4))'
        : 'white'};
  }
`

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const IconContainer = styled.div`
  display: none;
  align-items: center;
  justify-content: center;

  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--Background-Primary, #5a58f2);

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    display: flex;
  }
`

export const ItemLabel = styled.div<{ selected?: boolean }>`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    flex: 1;

    color: ${({ selected }) =>
      selected
        ? 'var(--Foreground-Primary, var(--Foreground-Primary, #4D4BE7))'
        : 'var(--Foreground-Neutral, #14171f)'};

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const EmptyItemLabel = styled.div`
  color: var(--Text-Tertiary, #8893a8);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const ItemHint = styled.div`
  color: var(--Text-Secondary, #4d5874);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export const ExpandContainer = styled.div<{ disabled?: boolean }>`
  display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
`

export const LoaderContainer = styled.div`
  width: 20px;
  height: 20px;
`
